import { EntityLabels, ListPageTitles } from "../../utils/navigation/pageTitles";
import { WasteMovementEditPage } from "../WasteReceivedEditPage/WasteMovementEditPage";

const WasteRemovedEditPage = () => (
    <WasteMovementEditPage
        config={{
            movementDirection: "Removed",
            listTitle: ListPageTitles.wasteRemoved,
            entityLabel: EntityLabels.wasteRemoved,
            listPath: "/waste-removed",
            siteStorageKey: "WasteRemovedListPage.siteId",
        }}
    />
);

export { WasteRemovedEditPage };
